<div class="table-container">
  <div class="table-wrapper">
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
        <thead class="thead-light">
          <tr>
            <th class="checkbox-column">
              <div class="position-relative d-inline-block text-right mr-2" dropdown>
                <button id="btn-filter-list" class="btn btn-secondary dropdown-toggle d-flex align-items-center pl-2" dropdownToggle type="button" >
                  <div class="custom-control custom-checkbox mr-1 d-inline-block">
                    <input type="checkbox" class="custom-control-input" name="checkAll" [id]="'checkAll'+'-'+tableConfig.type" [(ngModel)]="selectAll" (change)="onSelectAllChange($event)">
                    <label class="custom-control-label" [for]="'checkAll'+'-'+tableConfig.type"></label>
                  </div>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-left dropdown-menu-lg-right" role="menu">
                  <li role="menuitem" [id]="'filter-menu-list-'+i" *ngFor="let item of menuButtonList; let i = index;" >
                    <a type="button" class="dropdown-item" [id]="item.value" (click)="dropdownMenuAction($event, item)"  style="text-transform: none;">
                      <i [attr.class]="'mr-2 fa-solid ' + item?.icon" *ngIf="item?.icon"></i>{{item.label}}
                    </a>
                  </li>
                </ul>
              </div>
            </th>
            <th *ngFor="let column of columnConfig" 
                class="text-nowrap"
                [style.width]="column.width"
                [class.sortable]="column.sortable">
              {{column.name}}
            </th>
            <th *ngIf="tableConfig.actions?.length" class="text-nowrap action-column"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedItems; let i = index">
            <td class="checkbox-column">
              <div class="form-group mb-0">
                <div class="custom-control custom-checkbox pl-0">
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    [(ngModel)]="item.selected"
                    [id]="'check-'+item[tableConfig.idField]+'-'+tableConfig.type"
                    (change)="onItemSelectionChange()"
                  />
                  <label [for]="'check-'+item[tableConfig.idField]+'-'+tableConfig.type" class="custom-control-label"></label>
                </div>
              </div>
            </td>
            <td *ngFor="let column of columnConfig">
              <ng-container [ngSwitch]="column.renderer">
                <ng-container *ngSwitchCase="'badge'">
                  <span class="badge" [ngClass]="getBadgeClass(item, column)">
                    <i *ngIf="getBadgeIcon(item, column)" [class]=" 'fa ' + getBadgeIcon(item, column) + ' mr-1'"></i>
                    {{item[column.property] | titlecase}}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'icon'">
                  <i *ngIf="column.badgeConfig?.values[item[column.property]]?.icon"
                     [class]="column.badgeConfig.values[item[column.property]].icon + ' ' + 
                             column.badgeConfig.values[item[column.property]].class">
                  </i>
                </ng-container>

                <ng-container *ngSwitchCase="'custom'">
                  <ng-container *ngTemplateOutlet="column.customTemplate; context: { $implicit: item }">
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{item[column.property]}}
                </ng-container>
              </ng-container>
            </td>

            <td *ngIf="tableConfig.actions?.length" class="report-cell-content actions text-right" width="10">
                <div class="actions-column">
                    <div dropdown container="body">
                      <a id="table-btn-dropdown-{{i}}" class="btn btn-actions" dropdownToggle>
                        <i class="fa fa-gear" aria-hidden="true" style="color: var(--primary) !important;"></i>
                      </a>
                      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="profile-sm">
                        <ng-container *ngIf="getAvailableActions(item).length > 0">
                          <li role="menuitem" *ngFor="let action of getAvailableActions(item)" id="table-menuitem-{{i}}" style="cursor: pointer;">
                            <button id="table-btn-action-{{i}}" class="dropdown-item" (click)="executeAction(action, item)">
                              <i *ngIf="action.icon" [class]="action.icon + ' ' + action.iconClass"></i>
                              {{action.label}}
                            </button>
                          </li>
                        </ng-container>
                        <li *ngIf="getAvailableActions(item).length === 0" class="dropdown-item disabled">
                          No hay acciones disponibles para el estado actual
                        </li>
                      </ul>
                    </div>
                </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="pagination-container">
    <div class="col-sm-12 col-12 d-flex justify-content-sm-end align-items-end my-4 overflow-auto flex-column flex-sm-row">
      <div class="form-group mx-2 mb-2 mb-sm-0">
        <label class="mr-2">{{_appService.CoreCommonLiterals.RowsPerPage}}</label>
        <select class="form-control" [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
          <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{option}}</option>
        </select>
      </div>
      <button [disabled]="currentPage === 1" type="button" class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0" (click)="onPageChange(1)">
        <span>&lsaquo;</span> {{_appService.CoreCommonLiterals.FirstPage}}
      </button>
      <button [disabled]="currentPage === 1" type="button" class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0" (click)="onPageChange(currentPage - 1)">
        <span>&laquo;</span> {{_appService.CoreCommonLiterals.PreviousPage}}
      </button>
      <span class="mx-2 text-nowrap mb-2 mb-sm-0" *ngIf="getTotalPages() > 1">{{currentPage}} / {{getTotalPages()}}</span>
      <button [disabled]="currentPage >= getTotalPages()" type="button" class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0" (click)="onPageChange(currentPage + 1)">
        {{_appService.CoreCommonLiterals.NextPage}} <span>&raquo;</span>
      </button>
      <button [disabled]="currentPage >= getTotalPages()" type="button" class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0" (click)="onPageChange(getTotalPages())">
        {{_appService.CoreCommonLiterals.LastPage}} <span>&rsaquo;</span>
      </button>
    </div>
  </div>
</div>
